import PropTypes from "prop-types";
import React from "react";

const Cancel = ({showDesc, title}) => {
  return (
    <span className="Cancel">
      <span
        className="erg-margin-right-5 text-danger"
        title={!showDesc ? title : ""}>
        <i className="fa fa-ban" />
      </span>
      {showDesc ? <span className="icon-desc">{title}</span> : null}
    </span>
  );
};

Cancel.propTypes = {
  showDesc: PropTypes.bool,
  title: PropTypes.string,
};

Cancel.defaultProps = {
  title: "Cancelled Visit",
};

export default Cancel;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/icons/Cancel.js
 **/